import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material'
import { isEqual } from 'lodash'
import dayjs from 'dayjs'
import { TextField } from 'formik-material-ui'
import { Field, Form, Formik } from 'formik'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import CloseIcon from '@mui/icons-material/Close'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import DateTimeField from '../../../components/DateTimeField/DateTimeField'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'

const retornaDados = (u = []) => ({
  idConta: u?.[0] || undefined,
  idCategoriaConta: u?.[1]?.[0]?.[0] || undefined,
  acCategoriaConta: u?.[1] || [],
  idFormaPagamento: u?.[2]?.[0]?.[0] || undefined,
  acFormaPagamento: u?.[2] || [],
  idEmpresa: u?.[3]?.[0]?.[0] || undefined,
  acEmpresa: u?.[3] || [],
  nrDocumento: u?.[5] || '',
  dsConta: u?.[7] || '',
  dsObservacao: u?.[8] || '',
  dtVencimento: u?.[11] || '',
  dtEmissao: u?.[12] || '',
  dtPagamento: u?.[14] || undefined,
  vlConta: u?.[15] || '',
  idFornecedor: u?.[18]?.[0]?.[0] || undefined,
  acFornecedor: u?.[18] || [],
  idPlanoConta: u?.[19]?.[0]?.[0] || undefined,
  acPlanoConta: u?.[19] || [],
  idCentroCusto: u?.[20]?.[0]?.[0] || undefined,
  acCentroCusto: u?.[20] || [],
  idContaBancaria: u?.[21]?.[0]?.[0] || undefined,
  acContaBancaria: u?.[21] || [],
})

export const ModalContaAPagar = ({ show, handleClose, dados }) => {
  const formato = 'YYYY-MM-DD HH:mm:ss'

  const salva = async (values) => {
    const dataEmissao = dayjs(values.dtEmissao)
    if (!dataEmissao.isValid()) {
      values.dtEmissao = undefined
    } else {
      values.dtEmissao = dataEmissao.format(formato)
    }

    const dataVencimento = dayjs(values.dtVencimento)
    if (!dataVencimento.isValid()) {
      values.dtVencimento = undefined
    } else {
      values.dtVencimento = dataVencimento.format(formato)
    }

    const res = await metodoPrograma('salva', values)
    if (res.status) {
      handleClose()
    }
  }

  return (
    <Formik
      initialValues={retornaDados(dados)}
      enableReinitialize
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        await salva(values)
        setSubmitting(false)
        resetForm()
      }}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, resetForm }) => (
        <Form>
          <Dialog
            open={show}
            aria-label="close"
            keepMounted
            handleClose={() => {
              resetForm()
              handleClose()
            }}
            fullWidth={true}
            maxWidth={'lg'}
            md={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>Conta a Pagar</DialogTitle>
            <IconButton
              aria-label="close"
              onClick={() => {
                resetForm()
                handleClose()
              }}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    name="nrDocumento"
                    label="Nro Documento"
                    fullWidth
                    disabled={values.dtPagamento}
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    name="dsConta"
                    label="Nome da Conta"
                    fullWidth
                    disabled={values.dtPagamento}
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <CurrencyField
                    InputLabelProps={{ shrink: true }}
                    name="vlConta"
                    label="Valor"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.vlConta}
                    disabled={values.dtPagamento}
                    onChange={(v) => {
                      setFieldValue('vlConta', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Empresa"
                    metodo="buscaEmpresa"
                    value={values.acEmpresa}
                    size="small"
                    disabled={values.dtPagamento}
                    onChange={(_, v) => {
                      setFieldValue('idEmpresa', v?.[0]?.[0])
                      setFieldValue('acEmpresa', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Fornecedor"
                    metodo="buscaFornecedor"
                    value={values.acFornecedor}
                    disabled={values.dtPagamento}
                    onChange={(_, v) => {
                      setFieldValue('idFornecedor', v?.[0]?.[0])
                      setFieldValue('acFornecedor', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Plano de Conta"
                    metodo="buscaPlanoConta"
                    disabled={values.dtPagamento}
                    searchParams={{ idEmpresa: values?.idEmpresa || undefined }}
                    value={values.acPlanoConta}
                    onChange={(_, v) => {
                      setFieldValue('idPlanoConta', v?.[0]?.[0])
                      setFieldValue('acPlanoConta', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Centro de Custo"
                    metodo="buscaCentroCusto"
                    value={values.acCentroCusto}
                    disabled={values.dtPagamento}
                    searchParams={{ idEmpresa: values?.idEmpresa || undefined }}
                    onChange={(_, v) => {
                      setFieldValue('idCentroCusto', v?.[0]?.[0])
                      setFieldValue('acCentroCusto', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Conta Banária"
                    metodo="buscaContaBancaria"
                    value={values.acContaBancaria}
                    disabled={values.dtPagamento}
                    searchParams={{ idEmpresa: values?.idEmpresa || undefined }}
                    onChange={(_, v) => {
                      setFieldValue('idContaBancaria', v?.[0]?.[0])
                      setFieldValue('acContaBancaria', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Forma de Pagamento"
                    metodo="buscaFormaPagamento"
                    value={values.acFormaPagamento}
                    disabled={values.dtPagamento}
                    onChange={(_, v) => {
                      setFieldValue('idFormaPagamento', v?.[0]?.[0])
                      setFieldValue('acFormaPagamento', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Categoria"
                    metodo="buscaCategoriaConta"
                    value={values.acCategoriaConta}
                    disabled={values.dtPagamento}
                    onChange={(_, v) => {
                      setFieldValue('idCategoriaConta', v?.[0]?.[0])
                      setFieldValue('acCategoriaConta', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <DateTimeField
                    name="dtEmissao"
                    label="Emissão"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    disabled={values.dtPagamento}
                    value={values?.dtEmissao || null}
                    onChange={(v) => setFieldValue('dtEmissao', v)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <DateTimeField
                    name="dtVencimento"
                    label="Vencimento"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    disabled={values.dtPagamento}
                    value={values?.dtVencimento || null}
                    onChange={(v) => setFieldValue('dtVencimento', v)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    disabled={values.dtPagamento}
                    name="dsObservacao"
                    label="Observações"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <DateTimeField
                    InputLabelProps={{ shrink: true }}
                    name="dtPagamento"
                    label="Data de Pagamento"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    disabled
                    value={values?.dtPagamento || null}
                    onChange={(v) => setFieldValue('dtPagamento', v)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Forma de Pagamento"
                    metodo="buscaFormaPagamento"
                    value={values.acFormaPagamento}
                    disabled
                    onChange={(_, v) => {
                      setFieldValue('idFormaPagamento', v?.[0]?.[0])
                      setFieldValue('acFormaPagamento', v)
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <CurrencyField
                    InputLabelProps={{ shrink: true }}
                    name="vlQuitacao"
                    label="Valor Pago"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.vlQuitacao}
                    disabled
                    onChange={(v) => {
                      setFieldValue('vlQuitacao', v)
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  )
}

export default memo(ModalContaAPagar, isEqual)
